var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlusBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#343A40",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.465 25.389c.43 0 .78-.356.78-.76v-4.278h4.17c.416 0 .772-.349.772-.78 0-.424-.356-.779-.773-.779h-4.17v-4.28c0-.41-.348-.758-.78-.758-.423 0-.778.349-.778.759v4.279h-4.17c-.404 0-.773.355-.773.78 0 .43.37.779.773.779h4.17v4.279c0 .403.355.759.779.759z",
    transform: "translate(-318 -335) translate(16 167) translate(0 10) translate(214 145)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusBlack);
export default __webpack_public_path__ + "static/media/ic_plus_black.31720ed9ef1cc50dfa6a935204e553bd.svg";
export { ForwardRef as ReactComponent };